<template>
  <el-card body-style="padding:0px 20px" shadow="never">
    <h3 class="common-title mb10">项目沟通备注</h3>
    <div class="card-content">
      <div v-if="project.remark && project.remark.length > 0" class="context">
        <div v-for="(item, idx) in project.remark" :key="idx" class="remark-item">
          <div class="remark-item-title" style="margin-bottom:5px;font-size:14px;color:#409eff">
            <span style="margin-right:10px">{{ dateFormat(new Date(item.createAt), 'yyyy-mm-dd HH:MM') }}</span>
            <span>{{ item.user }}</span>
          </div>
          <div class="remark-item-content" style="font-size:14px;line-height:20px">
            <pre>{{ item.remark }}</pre>
          </div>
        </div>
      </div>
      <div>
        <el-input
          v-model="remark"
          type="textarea"
          style="margin-bottom:10px"
          placeholder="请填写沟通备注"
          :autosize="{ minRows: 3, maxRows: 5 }"
          @input="autoSaveRemarkLocal"
        ></el-input>
        <el-button type="primary" size="small" @click="saveRemark">保存</el-button>
      </div>
    </div>
  </el-card>
</template>
<script>
import { defaultProject, defaultCompany } from '../../constant/defaultData'

const dateFormat = require('dateformat')

export default {
  props: {
    project: { type: Object, default: () => window._.cloneDeep(defaultProject) },
    company: { type: Object, default: () => window._.cloneDeep(defaultCompany) },
    hasNotValueFields: { type: Array, default: () => [] },
  },
  data() {
    return {
      remark: '',
    }
  },
  computed: {
    dateFormat() {
      return dateFormat
    },
  },
  watch: {
    project: {
      async handler(value, oldValue) {
        if (value._id) this.getRemarkLocal()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    autoSaveRemarkLocal() {
      localStorage[`projectRemark${this.project._id}`] = this.remark
    },
    getRemarkLocal() {
      const remark = localStorage[`projectRemark${this.project._id}`]
      if (remark) this.remark = remark
    },
    clearRemarkLocal() {
      localStorage[`projectRemark${this.project._id}`] = ''
    },
    async saveRemark() {
      const remark = this.project.remark || []
      remark.unshift({
        createAt: new Date().getTime(),
        user: app.user.account,
        remark: this.remark,
      })
      await this.updateProject({ remark: remark })
      this.remark = ''
      this.clearRemarkLocal()
    },
    async updateProject(param = {}) {
      if (Object.keys(param).length === 0) return
      try {
        await app.service('project').modify({
          id: this.project._id,
          param: param,
        })
        Object.assign(this.project, param)
      } catch (e) {
        this.$message.error(`修改失败:${e.msg}`)
      }
    },
  },
}
</script>
<style scoped src="../../css/newProjectDetail.css"></style>
